import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-bar-gamification',
  templateUrl: './progress-bar-gamification.component.html',
  styleUrls: ['./progress-bar-gamification.component.css']
})
export class ProgressBarGamificationComponent {
  @Input() totals: number;
  @Input() completed: number;

  constructor() {}

  ngOnInit() {}
}
